import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getEdgeClass } from "../../utils";
import SVGSelector from "../common-components/SVGSelector";

const ViewAllContainedItemsModal = ({
  isContainedItemsModalOpen,
  setIsContainedItemsModalOpen,
  modalTitle,
  selectedValues,
}) => {
  const { t } = useTranslation();
  const { edge } = useSelector((state) => state?.uiConfig);
  return isContainedItemsModalOpen ? (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div
        className={`${getEdgeClass(edge, "rounded-md")} bg-[var(--white-shade)] w-[90%] max-w-sm max-h-[80vh] overflow-y-auto relative`}
      >
        <button
          onClick={() => setIsContainedItemsModalOpen(false)}
          className={`z-30 absolute top-2 right-2 text-[var(--text-white-black)] hover:text-gray-300 ${getEdgeClass(edge)} text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white`}
        >
          <SVGSelector
            name="cross-svg"
            pathStroke="currentColor"
            svgHeight={16}
            svgWidth={16}
            aria-hidden="true"
            focusable="false"
          />
        </button>

        <div
          className={`z-[20] sticky top-0 bg-[var(--primary-dark-color)] text-[var(--text-white-black)] py-3 ${getEdgeClass(edge, "rounded-tl-sm")} text-center`}
        >
          <div className="text-lg font-semibold break-words max-w-[22rem] px-4">
            {modalTitle}
          </div>
        </div>

        <div className="p-4">
          <div className="font-semibold text-sm mb-3">
            {t(
              "/vehicleDetails.The selected package includes the following features",
            )}
            :
          </div>
          {selectedValues.length ? (
            <ul className="list-disc ps-5 space-y-1 text-sm">
              {selectedValues.map((val, idx) => (
                <li key={idx}>{val}</li>
              ))}
            </ul>
          ) : (
            <p className="text-sm">{t("/vehicleDetails.No data found.")}</p>
          )}
        </div>
      </div>
    </div>
  ) : null;
};
export default ViewAllContainedItemsModal;
